module.exports = __webpack_public_path__ + "media/slot-game/pommes-99474449.svg";